import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import { NavigationLink, Separator } from './styled';
import TrackingEvents from '../../../common/models/TrackingEvents';

class BreadcrumbLink extends Component {
  componentDidMount() {
    const { linkId, trackingPayload } = this.props;
    if (trackingPayload) {
      mixpanel.track_links(`#${linkId}`, TrackingEvents.breadcrumbClicked(), trackingPayload);
    }
  }

  render() {
    const { linkId, name, url, trackingPayload } = this.props;
    return (
      <div key={linkId}>
        <Separator>&gt;</Separator>
        <NavigationLink id={linkId} href={url} data-cy={`link-breadcrumb-${name}`}>
          {name}
        </NavigationLink>
      </div>
    );
  }
}

BreadcrumbLink.propTypes = {
  key: PropTypes.number,
  name: PropTypes.string,
  url: PropTypes.string
};

export default BreadcrumbLink;
